import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "../../core/api";
import RecordPage from "../../components/RecordPage";
import { StatusBadge } from "../../components/Table";
import { useApp } from "../../core/AppContext";
import { formatDate } from "../../core/format";
import LeaveFlowModal from "./LeaveFlow";

import { requestPrint } from "../../core/printConfigs";


const isLeave = (r) => r.scope === "personal" && r.kind === "leave";

export default function Requests() {
  const { scope } = useParams();
  const { user, meta } = useApp();
  const admin = user.role === "admin";
  const canEditCreate = ["admin", "staff"].includes(user.role); // ← جدید

  const sc = scope === "org" ? "org" : "personal";
  const kinds = Object.entries(meta?.requestKinds?.[sc] || {}).map(
    ([value, label]) => ({ value, label }),
  );
  const statuses = Object.entries(meta?.requestStatus || {}).map(
    ([value, label]) => ({ value, label }),
  );
  const [subs, setSubs] = useState([]);
  const [flowId, setFlowId] = useState(null);

  useEffect(() => {
    if (sc !== "personal") return;
    api
      .get("/requests/leave/substitutes")
      .then((r) => setSubs(r.data.items))
      .catch(() => {});
  }, [sc]);

  return (
    <>
      <RecordPage
      printReport={requestPrint}
        key={sc}
        title={meta?.requestScopes?.[sc] || "درخواست‌ها"}
        endpoint="/requests"
        query={{ scope: sc }}
        createLabel="ثبت درخواست"
        subtitle={
          admin ? "بررسی و پاسخ به درخواست‌ها" : "درخواست‌های ثبت‌شده توسط شما"
        }
        canCreate={canEditCreate}
        canEdit={admin}
        canDelete={admin}
        fixed={{ scope: sc }}
        editFilter={(r) => !isLeave(r)}
        filters={[{ name: "status", label: "وضعیت", options: statuses }]}
        columns={[
          {
            key: "createAt",
            label: "تاریخ ثبت",
            render: (r) => formatDate(r.createAt),
          },
          {
            key: "kind",
            label: "موضوع",
            render: (r) => meta?.requestKinds?.[r.scope]?.[r.kind] || r.kind,
          },
          { key: "title", label: "عنوان", render: (r) => <b>{r.title}</b> },
          {
            key: "range",
            label: "بازه",
            render: (r) =>
              r.fromDate
                ? `${formatDate(r.fromDate)}${r.toDate ? ` تا ${formatDate(r.toDate)}` : ""}`
                : "—",
          },
          {
            key: "status",
            label: "وضعیت",
            render: (r) => (
              <StatusBadge
                status={r.status}
                label={meta?.requestStatus?.[r.status]}
              />
            ),
          },
          {
            key: "adminNote",
            label: "پاسخ",
            render: (r) => (
              <div className="clip" title={r.adminNote || ""}>
                {r.adminNote || "—"}
              </div>
            ),
          },
          ...(admin ? [{ key: "creatorName", label: "درخواست‌دهنده" }] : []),
        ]}
        getFields={(form) => {
          const hasRange = (meta?.rangeRequestKinds?.[sc] || []).includes(
            form.kind,
          );
          const isLeave = sc === "personal" && form.kind === "leave";

          return [
            {
              name: "kind",
              label: "موضوع درخواست",
              type: "select",
              options: kinds,
              required: true,
            },
            { name: "title", label: "عنوان", required: true },
            {
              name: "fromDate",
              label: hasRange ? "از تاریخ" : "تاریخ",
              type: "date",
              required: hasRange,
              full: !hasRange,
            },
            {
              name: "toDate",
              label: "تا تاریخ",
              type: "date",
              required: hasRange,
              hidden: !hasRange,
            },
            {
              name: "substituteId",
              label: "معرفی جانشین",
              type: "select",
              required: true,
              full: true,
              hidden: !(isLeave && !form.id),
              options: subs.map((s) => ({
                value: s.id,
                label: s.positionName
                  ? `${s.name} — ${s.positionName}`
                  : s.name,
              })),
              hint: subs.length
                ? "ابتدا برای جانشین، سپس مسئول ایمنی و آتش‌نشانی و در نهایت مدیر بندر ارسال می‌شود."
                : "کارمندی با حساب کاربری فعال برای جانشینی یافت نشد",
            },
            { name: "description", label: "توضیحات", type: "textarea" },
            {
              name: "status",
              label: "وضعیت",
              type: "select",
              options: statuses,
              hidden: !(admin && form.id) || isLeave,
              full: true,
            },
            {
              name: "adminNote",
              label: "پاسخ / توضیح",
              hidden: !(admin && form.id) || isLeave,
              full: true,
            },
          ];
        }}
        toForm={(r) => ({
          ...r,
          fromDate: r.fromDate || "",
          toDate: r.toDate || "",
        })}
        rowExtra={(r) =>
          isLeave(r) ? (
            <button
              className="icon-btn"
              title="مراحل تأیید مرخصی"
              onClick={() => setFlowId(r.id)}
            >
              <i className="fa-solid fa-list-check" />
            </button>
          ) : null
        }
      />
      {flowId && <LeaveFlowModal id={flowId} onClose={() => setFlowId(null)} />}
    </>
  );
}
